import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { Dialog, DialogContent, DialogTrigger } from '@app/lib/disclosure/Dialog/Dialog'
import { useDialog } from '@app/lib/disclosure/Dialog/useDialog'
import { Button } from '@app/lib/inputs/Button/Button'
import { Heading } from '@app/lib/typography/Heading/Heading'
import { MissedPhoneAppointmentForm } from '@app/modules/Messages/Components/MissedPhoneAppointment/MissedPhoneAppointmentForm'

import './MissedPhoneAppointment.scss'

export type Props = {
  messageId: number
}

export const MissedPhoneAppointment = ({ messageId }: Props) => {
  const { openDialog, dialogProps, closeDialog } = useDialog()
  const { formatMessage } = useIntl()
  const b = bemJoin('missed-phone-appointment')

  return (
    <Dialog {...dialogProps}>
      <DialogTrigger>
        <Button color={'secondary'} variant={'solid'} onClick={openDialog} className={b('button')}>
          {formatMessage({ id: 'MissedPhoneAppointment.OpenDialogButton' })}
        </Button>
      </DialogTrigger>

      <DialogContent
        title={<Heading>{formatMessage({ id: 'MissedPhoneAppointment.Form.Heading' })}</Heading>}
      >
        <MissedPhoneAppointmentForm onClose={closeDialog} messageId={messageId} />
      </DialogContent>
    </Dialog>
  )
}
